import { errorManagerInstance } from '@app/engine/utils/errorManager';
import { getEl, showEl } from '@app/engine/utils/get-el';
import { keepTrackApi } from '@app/keepTrackApi';
import { SoundNames } from '@app/plugins/sounds/sounds';
import Draggabilly from 'draggabilly';
import './engine-ui.css';
import { html } from '../utils/development/formatter';
export class DraggableBox {
    boxId;
    boxEl = null;
    draggie = null;
    width = null;
    title = '';
    static zIndexCounter_ = 10000;
    isDockable = false;
    static getMaxZIndex() {
        return this.zIndexCounter_;
    }
    static increaseMaxZIndex() {
        this.zIndexCounter_ += 1;
        return this.zIndexCounter_;
    }
    constructor(boxId, opts) {
        this.boxId = boxId;
        this.title = opts?.title ?? '';
        this.width = opts?.width ?? '300px';
        this.isDockable = opts?.isDockable ?? false;
    }
    onOpen() {
        getEl(`${this.boxId}-close`).addEventListener('click', () => this.close());
        if (this.isDockable) {
            getEl(`${this.boxId}-dock`).addEventListener('click', () => this.dock());
        }
        this.sendToFront();
    }
    open(cb) {
        if (!this.boxEl) {
            getEl('canvas-holder').insertAdjacentHTML('beforeend', html `
        <div id="${this.boxId}" class="draggable-box" style="pointer-events:auto;">
          <div class="draggable-box__title-bar">
            <div class="draggable-box__title">
              <span>
                ${this.getBoxTitleHtml()}
              </span>
            </div>
            ${this.isDockable ? `<span id="${this.boxId}-dock" class="draggable-box__btn draggable-box__dock-btn"></span>` : ''}
            <span id="${this.boxId}-close" class="draggable-box__btn draggable-box__close-btn"></span>
          </div>
          <div class="draggable-box__content">
            ${this.getBoxContentHtml()}
          </div>
        </div>
      `);
            this.boxEl = getEl(this.boxId);
            this.initDraggabilly_();
            this.onOpen();
        }
        if (this.boxEl) {
            showEl(this.boxEl);
            const boxContent = getEl(`${this.boxId}`);
            if (this.width) {
                boxContent.style.width = this.width;
            }
            if (cb) {
                cb();
            }
            // Center the box after cb to ensure correct offsetHeight/offsetWidth
            boxContent.style.top = `${(window.innerHeight - boxContent.offsetHeight) / 2}px`;
            boxContent.style.left = `${(window.innerWidth - boxContent.offsetWidth) / 2}px`;
            this.sendToFront();
        }
        else {
            errorManagerInstance.log(`Failed to open box: ${this.boxId}`);
        }
    }
    getBoxTitleHtml() {
        return this.title;
    }
    initDraggabilly_() {
        const boxContent = getEl(`${this.boxId}`);
        if (boxContent && !this.draggie) {
            this.draggie = new Draggabilly(boxContent, {
                containment: getEl('canvas-holder'),
            });
            this.draggie.on('dragStart', () => {
                boxContent.style.height = 'fit-content';
                boxContent.style.maxHeight = '80%';
            });
            this.draggie.on('pointerDown', () => {
                this.sendToFront();
            });
            boxContent.addEventListener('mousedown', (e) => {
                if (e.button === 2) {
                    boxContent.style.top = `${(window.innerHeight - boxContent.offsetHeight) / 2}px`;
                    boxContent.style.left = `${(window.innerWidth - boxContent.offsetWidth) / 2}px`;
                    this.sendToFront();
                }
            });
        }
    }
    sendToFront() {
        getEl(`${this.boxId}`).style.zIndex = DraggableBox.increaseMaxZIndex().toString();
    }
    close(cb) {
        if (this.boxEl) {
            this.boxEl.style.display = 'none';
            keepTrackApi.getSoundManager()?.play(SoundNames.CLICK);
            if (cb) {
                cb();
            }
        }
    }
    dock(cb) {
        if (this.boxEl) {
            this.boxEl.style.display = 'none';
            keepTrackApi.getSoundManager()?.play(SoundNames.CLICK);
            if (cb) {
                cb();
            }
        }
    }
}
